/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { useAppTheme } from '@hooks/useAppTheme';
import { RootState } from '@state-mgmt/store';
import { styles } from './styles';

export interface Props {
  onDelete: () => void;
  onClose: () => void;
}

const DeleteUploadConfirmationModal = ({ onDelete, onClose }: Props) => {
  const { t } = useTranslation();
  const theme = useAppTheme({});
  const { themeMode } = useSelector((state: RootState) => state.app);

  return (
    <div css={styles.container(themeMode)}>
      <DialogTitle> {t('delete-upload-confirmation.title')}</DialogTitle>
      <DialogContent>
        <Typography css={styles.message}> {t('delete-upload-confirmation.text')}</Typography>
      </DialogContent>
      <DialogActions css={styles.actionsContainer(theme)}>
        <Button variant="outlined" onClick={() => onClose()} css={styles.actionsBtn}>
          {t('general.cancel')}
        </Button>
        <Button
          css={styles.actionsBtn}
          variant="contained"
          onClick={async () => {
            onDelete();
            onClose();
          }}
        >
          {t('general.confirm')}
        </Button>
      </DialogActions>
    </div>
  );
};

export default DeleteUploadConfirmationModal;
